(function () {
  function getStep(track) {
    var firstItem = track && track.querySelector('.featured-collection-showcase__item');
    if (!firstItem) return 0;

    var itemStyles = window.getComputedStyle(firstItem);
    var itemWidth = firstItem.getBoundingClientRect().width;
    var gap = parseFloat(itemStyles.marginRight) || 0;

    if (!gap) {
      var trackStyles = window.getComputedStyle(track);
      gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
    }

    return itemWidth + gap;
  }

  function updateControls(track, prev, next) {
    if (!track || !prev || !next) return;

    var maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
    var scrollLeft = Math.round(track.scrollLeft);
    var atStart = scrollLeft <= 2;
    var atEnd = scrollLeft >= Math.max(0, maxScrollLeft - 2);
    var canScroll = maxScrollLeft > 2;

    prev.classList.toggle('is-disabled', !canScroll || atStart);
    next.classList.toggle('is-disabled', !canScroll || atEnd);
  }

  function initFeaturedCollectionShowcase(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-featured-collection]').forEach(function (section) {
      if (section.dataset.featuredCollectionInitialized === 'true') return;
      section.dataset.featuredCollectionInitialized = 'true';

      if (section.dataset.carouselEnabled !== 'true') return;

      var track = section.querySelector('[data-featured-collection-track]');
      var prev = section.querySelector('[data-featured-collection-prev]');
      var next = section.querySelector('[data-featured-collection-next]');

      if (!track || !prev || !next) return;

      function move(direction) {
        var step = getStep(track);
        if (!step) return;

        track.scrollBy({
          left: step * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      prev.addEventListener('click', function () {
        move(-1);
      });

      next.addEventListener('click', function () {
        move(1);
      });

      track.addEventListener('scroll', function () {
        updateControls(track, prev, next);
      }, { passive: true });

      window.addEventListener('resize', function () {
        updateControls(track, prev, next);
      }, { passive: true });

      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(function () {
          updateControls(track, prev, next);
        });
        observer.observe(track);
      }

      requestAnimationFrame(function () {
        updateControls(track, prev, next);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFeaturedCollectionShowcase(document);
    });
  } else {
    initFeaturedCollectionShowcase(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFeaturedCollectionShowcase(event.target);
  });
})();
